<template>
	<div>
		<div class="tableView">
			<div class="table_list">
				<span style="line-height: 32px">名称:</span>
				<el-input v-model="select.selectName" placeholder="请输入项目名称" @clear="getApplication" :clearable="true"
					style="margin-left: 10px;width: 200px;"></el-input>
			</div>
			
			<!--<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">项目类型:</span>
				<el-select v-model="select.selectValue1" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange1">
					<el-option v-for="(item, index) in select.options1" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>-->
			<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">状态:</span>
				<el-select v-model="select.selectValue2" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange2">
					<el-option v-for="(item, index) in select.options2" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>
			<div>
				<el-button type="primary" style="margin-left: 20px" @click="searchData">
					查询
				</el-button>

<!--				<el-button type="primary" @click="report">统一推荐</el-button>-->

			</div>
		</div>
		<!-- 表格 -->
		<normalTable :check="true" @checkbox="checkBox" v-loading="loading" :tabList="tabList" :tableList="tableList" @copol-click="reciveClick">
		</normalTable>

		<div style="margin-top: 50px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>

		<!-- 弹窗 -->
		<payMoney ref="paymoney"></payMoney>
		<huizong_table ref="huizong_table"></huizong_table>

	</div>
</template>

<script>
	import {
		getAppliInfo,
		getProjectType
	} from '../../api/moudles/application.js'


	import {

		report
	} from '../../api/moudles/management.js'

	import payMoney from './components/payMoney.vue'
	import normalTable from '../../components/table/normalTable.vue'
	import huizong_table from "./components/huizong_table";

	export default {
		data() {
			return {
				select: {
					options1: [],
					options2: [],
					selectName: '',
					selectValue1: '',
					selectValue2: ''
				},
				tabList: [ '项目名称', '申请时间', '审核时间','已提交', '已退回', '已审核', '已推荐', '状态', '动作'],
				tableList: [],
				tabCodeList: [],
				loading: false,
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0,
				ids:[]
			}
		},
		components: {
			payMoney,
			normalTable,
			huizong_table,
		},
		created() {
		/*	this.level()*/
			this.getApplication()
			this.getProjecttype()
		},
		methods: {


			async reportApi(ids){

				/*if (!this.ids.length) {
					this.$message.error('请先选中数据')
					return
				}*/
				const params = {
					ids: ids
				}

				await report({
					data: params,
					success: res => {

						if (res.code === 200) {

							this.$message({
								message: res.msg,
								type: 'success'
							});

							this.dialogVisible = false

							setTimeout(() => {
								location.reload()
							}, 1500)

						} else {
							this.$message.error(res.msg)
						}

					}
				})
			},

			report(){
				if (!this.ids.length) {
					this.$message.error('请先选中数据')
					return
				}
				let that  = this
				this.$confirm("是否确认统一推荐，推荐后不能申报和审核哦?", "提示", {
					iconClass: "el-icon-question", //自定义图标样式
					confirmButtonText: "确认", //确认按钮文字更换
					cancelButtonText: "取消", //取消按钮文字更换
					showClose: true, //是否显示右上角关闭按钮
					type: "warning", //提示类型  success/info/warning/error
				})
					.then(function () {  //选择确认进入此方法
						//确认操作

						that.reportApi()

					})
					.then(() => {  //上一个then()执行成功后执行后续方法

					})
					.catch(function (err) { //取消按钮会视为erro
						//debugger;
						//捕获异常
						console.log(err);
					});

			},

			// 复选框
			checkBox(e) {
				// console.log('接收到复选框', e)
				const newList = []

				console.log(this.tabCodeList)

				e.forEach((item, index) => {
					if (item === true) {
						newList.push(this.tabCodeList[index])
					}
				})

				this.ids = newList
			},

			// 获取下拉选项
			async getProjecttype() {
				await getProjectType({
					data: {},
					success: res => {
						console.log(res)
						const typeAll = res.data.typeAll
						const statusAll = res.data.statusAll
						const newtypeAll = []
						const newStatusAll = []
						
						Object.keys(typeAll).forEach((item, index) => {
							const newList = {}
							newList.text = typeAll[item]
							newtypeAll.push(newList)
						})
						statusAll.forEach((item, index) => {
							const newList = {}
							newList.text = item
							newStatusAll.push(newList)
						})
						this.select.options1 = newtypeAll
						this.select.options2 = newStatusAll
					}
				})
			},
			selectChange1() {
				// console.log(this.select.selectValue1)
			},
			selectChange2() {
				// console.log(this.select.selectValue2)
			},
			searchData() {
				this.getApplication()
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getApplication()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getApplication()
			},
			// 二级管理员跳转
			level() {
				const level = localStorage.getItem('userLevel')
				if (level === '2') {
					// console.log('2', level)
					this.$router.replace('/infochange')
				}
			},
			async getApplication() {
				const params = {
					name: this.select.selectName,
					project_type: 8,
					status: this.select.selectValue2,
					page: this.currentPage,
					limit: this.pageSize
				}
				this.loading = true
				await getAppliInfo({
					data: params,
					success: (res) => {
						// console.log('获取信息', res)
						this.totalNum = res.totalCount
						let dataList = res.data;
						let upCode = []
						let upList = []
						dataList.forEach((item) => {
							let newlist = {}
							//newlist['project_type_name'] = item.project_type_name
							newlist['project_name'] = item.project_name
							newlist['apply_time'] = item.apply_time
							newlist['app_time'] = item.app_time
              newlist['collect_count'] = item.enp.collect_count
              newlist['giveback_count'] = item.enp.giveback_count
              newlist['app_count'] = item.enp.app_count
              newlist['recd_count'] = item.enp.recd_count
							newlist['status_name'] = item.enp.status_name
							if(item.enp.status_name == "已结束"){
                newlist['soqcol'] = ['查看明细']
							}else{
                newlist['soqcol'] = ['查看明细','统一推荐']
							}

							upCode.push(item.project_code)
							upList.push(newlist)
						})
						this.tabCodeList = upCode
						this.tableList = upList
						this.loading = false
					}
				})
			},
			// 弹窗
			payMoney() {
				this.$refs['paymoney'].showPay()
			},
			showCopol(key) {
				 console.log('key', key)
				this.payMoney()
			},
			// 接受子组件事件
			reciveClick(e) {
				console.log('e', e)

				if(e.list =='查看明细'){

          this.$router.push('/recomedcontribute')

				}else if(e.list =='统一推荐'){
					const {
						key
					} = e

          let that  = this
          this.$confirm("是否确认统一推荐，推荐后不能申报和审核哦?", "提示", {
            iconClass: "el-icon-question", //自定义图标样式
            confirmButtonText: "确认", //确认按钮文字更换
            cancelButtonText: "取消", //取消按钮文字更换
            showClose: true, //是否显示右上角关闭按钮
            type: "warning", //提示类型  success/info/warning/error
          })
              .then(function () {  //选择确认进入此方法
                //确认操作
                that.reportApi(that.tabCodeList[key])
              })
              .catch(function (err) { //取消按钮会视为erro
                //debugger;
                //捕获异常
                console.log(err);
              });

				}

			}
		}
	}
</script>

<style scoped="scoped">
	.tableView {
		display: flex;
		margin: 20px 0;
		flex-wrap: wrap;
	}
	.table_list{
		margin-bottom: 10px;
	}
</style>
